import onefinity from '@/assets/onefinity.png';

interface IconProps {
  width?: string;
  height?: string;
  className?: string;
  alt?: string;
}

function Onefinity({
  width = '200',
  height = '70',
  className = '',
  alt = 'Onefinity',
}: IconProps) {
  return (
    <img
      src={onefinity}
      alt={alt}
      width={width}
      height={height}
      className={className}
    />
  );
}

export default Onefinity;
